import { type OutputFormData } from '@ikea-customer-self-serve/contact-form';
import {
  type AvailableService,
  type AvailableStore,
} from '../services/appointment/model';
import {
  isServiceProvidedRemote,
  isServiceProvidedAtHome,
} from '../helpers/appHelper';

export const getEventLocation = (
  contact: OutputFormData,
  remoteEventLocation: string,
  store?: AvailableStore,
  service?: AvailableService,
): string => {
  if (service) {
    const { location } = service;
    if (isServiceProvidedRemote(location)) {
      return remoteEventLocation;
    }

    if (isServiceProvidedAtHome(location)) {
      const { address1, city, firstName, surName } = contact;
      return `${firstName} ${surName}, ${address1}, ${city}`;
    }

    if (store) {
      const { text, street, city } = store;
      return `${text}, ${street}, ${city}`;
    }
  }
  return '';
};

export const getIsMobileChanged = (
  contactMobileNumber: string,
  userPhoneNumber?: string,
): boolean => userPhoneNumber !== contactMobileNumber;
